import api from "./client";

export interface RecallCampaignVehicle {
  id: string;
  vin: string;
  plate: string;
  marque: string;
  modele: string;
  ordre_id?: string;
  dossier_id?: string;
  status: "detected" | "acknowledged" | "treated";
  detected_at: string;
}

export interface RecallCampaignGroup {
  campaign_code: string;
  campaign_title: string;
  total: number;
  treated: number;
  vehicles: RecallCampaignVehicle[];
}

export interface RecallCampaignEntry {
  id: string;
  campaign_code: string;
  campaign_title: string;
  status: "detected" | "acknowledged" | "treated";
  detected_at: string;
}

export interface CampaignCheckResult {
  /** "found" = campaigns listed · "none" = checked, nothing open · "unavailable" = we don't know */
  status: "found" | "none" | "unavailable";
  campaigns: { code: string; libelle: string }[];
}

export const recallCampaignsApi = {
  listGrouped: async (orgId: string): Promise<RecallCampaignGroup[]> => {
    const { data } = await api.get("/recall-campaigns", {
      params: { org_id: orgId },
    });
    return data;
  },

  listForOrdre: async (ordreId: string): Promise<RecallCampaignEntry[]> => {
    const { data } = await api.get(
      `/recall-campaigns/ordre/${ordreId}`
    );
    return data;
  },

  updateStatus: async (
    campaignId: string,
    status: string
  ): Promise<RecallCampaignEntry> => {
    const { data } = await api.post(
      `/recall-campaigns/${campaignId}/status`,
      { status }
    );
    return data;
  },

  /** Booking flow: are there open campaigns on this plate? Run before any ordre
   *  exists, so a campagne-only RDV is never taken for a vehicle none targets. */
  checkForBooking: async (
    orgId: string,
    plate: string,
    vehicleId?: string
  ): Promise<CampaignCheckResult> => {
    const { data } = await api.get("/recall-campaigns/check-booking", {
      params: { org_id: orgId, plate, ...(vehicleId ? { vehicle_id: vehicleId } : {}) },
    });
    return data;
  },

  /** No campaign detected but the client insists — email the garage instead of
   *  loading the planning with an RDV it may have to cancel. */
  sendRequest: async (
    orgId: string,
    payload: { plate?: string; vehicle?: string; nom?: string; prenom?: string; phone?: string; email?: string; message: string }
  ): Promise<{ sent: boolean }> => {
    const { data } = await api.post("/recall-campaigns/request", payload, {
      params: { org_id: orgId },
    });
    return data;
  },

  checkVin: async (
    orgId: string,
    vin: string,
    plate?: string,
    ordreId?: string
  ): Promise<{ code: string; libelle: string }[]> => {
    const { data } = await api.post("/recall-campaigns/check", {
      vin,
      plate: plate || "",
      ordre_id: ordreId,
    }, { params: { org_id: orgId } });
    return data;
  },
};
